export const spacingLayouts = [
  'dense',
  'clever',
  'vertical__clever',
  'horizontal__clever',
] as const;

export type TSpacingLayout = (typeof spacingLayouts)[number];

export function getSpacingLayouts() {
  return {
    '&.dense': {
      px: 0,
      py: 0,
    },
    '&.horizontal__clever': {
      px: 4,
      py: 0,
    },
    '&.vertical__clever': {
      px: 0,
      py: 4,
    },
    '&.clever': {
      px: 4,
      py: 4,
    },
  };
}
